// extracted by mini-css-extract-plugin
module.exports = {"root":"Preload_root__JSGl_"};